import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { navigationPages } from '@/config';

import { TopNavLink } from './components/TopNavLink';

import styles from './TopNav.module.sass';

const pages = [navigationPages.TRACE_INVESTIGATIONS, navigationPages.TARIFFS];

interface TopNavProps {}

const TopNav: FC<TopNavProps> = () => {
  const { t } = useTranslation();

  return (
    <nav className={styles.nav}>
      {pages.map(({ path, iconName, i18NameKey }) => (
        <TopNavLink
          key={path}
          to={path}
          iconName={iconName}
          text={t(i18NameKey)}
        />
      ))}
    </nav>
  );
};

export default TopNav;
